module.exports = __webpack_public_path__ + "static/InsightsBgSmall-3d9165b8a08c67bb2cdb5ddee791600c.png";